// extracted by mini-css-extract-plugin
export var active = "_2z-7";
export var backButton = "_2z-6";
export var clone = "_2z-c";
export var collapseBar = "_2z-h";
export var collapseMode = "_2z-j";
export var collapsed = "_2z-l";
export var dragHandle = "_2z-a";
export var dropdownIcon = "_2z-e";
export var expanding = "_2z-k";
export var hidden = "_2z-r";
export var iconContainer = "_2z-o";
export var iconSwapper = "_2z-q";
export var navItem = "_2z-4";
export var navItemIcon = "_2z-d";
export var navProfile = "_2z-5";
export var notificationCountBadge = "_2z-g";
export var notificationDot = "_2z-p";
export var optionsContainer = "_2z-f";
export var primaryNav = "_2z-0";
export var primaryTab = "_2z-m";
export var secondaryNav = "_2z-1";
export var selected = "_2z-n";
export var settingsNav = "_2z-2";
export var settingsNavItems = "_2z-3";
export var show = "_2z-b";
export var sideNav = "_2z-i";
export var teamItem = "_2z-8";
export var userProfileItem = "_2z-9";